/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import { IQueryConfigArgs } from "../../common/types";
import firebase, { functions } from "../../config/firebase";

export const db = firebase.firestore();
export const dbFunctions = functions;

export const dataFromSnapshot = (snapshot: any) => {
  if (!snapshot.exists) return undefined;
  const data = snapshot.data();
  for (const prop in data) {
    if (data.hasOwnProperty(prop)) {
      if (data[prop] instanceof firebase.firestore.Timestamp) {
        data[prop] = data[prop].toDate();
      }
    }
  }
  return { ...data, id: snapshot.id };
};

export const dataFromSnapshotData = (data: any) => {
  for (const prop in data) {
    if (data.hasOwnProperty(prop)) {
      if (data[prop] instanceof firebase.firestore.Timestamp) {
        data[prop] = data[prop].toDate();
      }
    }
  }
  return { ...data };
};
export const collectionWithArgs = (ref: any, args: IQueryConfigArgs[]) => {
  args.forEach((v) => {
    switch (v?.type) {
      case "filter":
        if (!v.value || v.value === "") break;
        ref = ref.where(v.name, v.opr, v.value);
        break;
      case "sorting":
        ref = ref.orderBy(v.name, v.opr);
        break;
      case "limit":
        ref = ref.limit(v.value?.end).startAt(v.value?.start);
        break;
      default:
        break;
    }
  });

  return ref;
};
